// AddAddressForm



import useTranslations from "../../providers/useTranslations";

import { capitalize } from "../../lib/utils";

function AddAddressForm(props) {
  const [city, setCity] = React.useState(null)
  const [province, setProvince] = React.useState(null)
  const [address, setAddress] = React.useState(null)
  const [barrio, setBarrio] = React.useState(null)
  const [name, setName] = React.useState(null)
  const [phone, setPhone] = React.useState(null)
  const [itiField, setItiField] = React.useState(null)
  const [email, setEmail] = React.useState("")
  const [instructions, setInstructions] = React.useState(null)
  const [barrios, setBarrios] = React.useState([]);

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const [nickname, setNickname] = React.useState(tr('Home'))

  React.useEffect(() => {
    console.log("useEffect", props.city, props.province)
    setCity(props.city)
    setProvince(props.province)

    const input = document.querySelector("#add-address-phone");

    console.log("input", input)

    let iti = window.intlTelInput(input, {
      i18n: "es",
      initialCountry: "CO",
      autoPlaceholder: "off",
    //   //loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.1/build/js/utils.js"),
    });

    setItiField(iti)

  }, [props.city, props.province, props.country]);

  const doSubmit = () => {
    if (name === null || name.length < 3) {
      alert(tr("Please enter a contact name"))
      return
    }

    if (city === null || city.length < 3) {
      console.log("city", city)
      alert(tr("Please enter a valid city"))
      return
    }

    if (address === null || address.length < 5) {
      console.log("address", address)
      alert(tr("Please enter a valid address"))
      return
    }
    let phoneNumber = itiField.getNumber()
    if (phoneNumber === null || phoneNumber.length < 12) {
      console.log("phone", phoneNumber)
      alert(tr("Please enter a valid phone number"))
      return
    }

    let addressObj = {
      name: name,
      city: city,
      province: province,
      address: address,
      barrio: barrio,
      phone: phoneNumber,
      email: email.trim(),
      title: nickname,
      instructions: instructions
    }

    //console.log("doSubmit", addressObj)

    props.onSubmit(addressObj)
  }

  return (

    <div className="m-2"  centered="true"  >


    <div className="">
      <form>
        <div className="form-row">

          <div className="form-group col-md-12">
            <label>{tr("Name")}</label>
            <input className="form-control" type="text" placeholder={tr("Contact name")}
              onChange={(event) => {
                // console.log("phone", event.target.value)
                setName(event.target.value)
              }} />
          </div>

          <div className="form-group col-md-12">
            <label>{tr("Address")}</label>
            <input className="form-control" type="text" placeholder={tr("Complete Address e.g. house number, street name, landmark")}
              onChange={(event) => {
                // console.log("address", event.target.value)
                setAddress(event.target.value)
              }}
            />
          </div>

          {props.barrios && props.barrios.length > 0 && props.location && props.location.flags && props.location.flags.includes("barrioPricing") &&

            <div className="form-group col-md-12">
              <label>{tr("Barrio")}</label>
              <select
                className="form-control"
                onChange={(e) => {
                  setBarrio(e.target.value)
                }}
              >
                <option value="">Eligir Barrio</option>
                {barrios.map((barrio) => {
                  return <option key={barrio} value={capitalize(barrio)}>
                    {capitalize(barrio)}</option>
                })}
              </select>

            </div>
          }


          <div className="form-group col-md-12">
            <label>{tr("City")}</label>
            <div className="input-group" >
              <input className="form-control" type="text" placeholder={tr("City")}
                defaultValue={city}
                onChange={(event) => {
                  // console.log("city", event.target.value)
                  setCity(event.target.value)
                }}
              />
              {/*
              <div className="input-group" .Append>
                 <button type="button" className="btn btn-outline-secondary"  type="button" id="button-addon2"><i className="icofont-ui-pointer"/></button>
              </div .Append>
            */}
            </div>
          </div>

          <div className="form-group col-md-12">
            <label>{tr("Province")}</label>
            <div className="input-group" >
              <input className="form-control" type="text" placeholder={tr("Province")}
                defaultValue={province}
                onChange={(event) => {
                  // console.log("province", event.target.value)
                  setProvince(event.target.value)
                }}
              />

            </div >
          </div>

          <div className="form-group col-md-12">
            <label>{tr("Phone")}</label>
            <input id="add-address-phone" type="tel"
              onChange={(event) => {
                // does not get called when using intlTelInput
                console.log("phone", event)
                setPhone(event)
              }}
              style={{ width: "100%" }}
            />
            {/* <div className='row' style={{paddingRight:"15px"}}>
              <label className='col-2 centrar' style={{padding:0, margin:0, display:"flex", alignItems:"center", justifyContent:"center"}}><img src={flag} alt='icon-flag'/></label>
              <div   className='form-control col-10' type="text" placeholder={tr("Contact phone number")}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setPhone(event.target.value)
                }} />
            </div> */}
          </div>

          <div className="form-group col-md-12">
            <label>{tr("Email")}</label>
            <input className="form-control" type="text" placeholder={tr("Email for confirmation and receipt")}
              onChange={(event) => {
                // console.log("phone", event.target.value)
                setEmail(event.target.value)
              }} />
          </div>

          <div className="form-group col-md-12">
            <label>{tr("Delivery Instructions")}</label>
            <input className="form-control" type="text" placeholder={tr("Delivery Instructions e.g. Ring top bell")}
              onChange={(event) => {
                // console.log("instructions", event.target.value)
                setInstructions(event.target.value)
              }}
            />
          </div>

          <div className="form-group mb-0 col-md-12">
            <label>{tr("Nickname")}</label>
            <div role="toolbar" className="btn-toolbar">
              <div role="group" className="d-flex w-100 btn-group btn-group-toggle"
                onChange={(val) => {
                  console.log("nickname", val.target.value)
                  switch (val.target.value) {
                    case 1:
                      setNickname(tr("Home"))
                      break;

                    case 2:
                      setNickname(tr("Work"))
                      break;

                    case 3:
                      setNickname(tr("Other"))
                      break;
                    default:
                      setNickname(tr("Unknown"))
                  }
                }}
              >
                <label className="btn active btn-info">
                  <input name="options" type="radio" autoComplete="off" value="1"  />{tr("Home")}
                </label>
                <label className="btn btn-info">
                  <input name="options" type="radio" autoComplete="off" value="2" />{tr("Work")}
                </label>
                <label className="btn btn-info">
                  <input name="options" type="radio" autoComplete="off" value="3" />{tr("Other")}
                </label>

              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div className="new-address-footer">
      <button type='button' onClick={props.onHide} className="btn btn-outline-primary d-flex w-50 text-center justify-content-center">{tr("CANCEL")}</button>
      <button type='button' className='btn btn-primary d-flex w-50 text-center justify-content-center'
        onClick={doSubmit}
      >{tr("SUBMIT")}</button>
    </div>
  </div>
  );
}
export default AddAddressForm;


/*
// AddAddressForm


function AddAddressFormModal(props) {
  const [city, setCity] = React.useState(null)
  const [province, setProvince] = React.useState(null)
  const [address, setAddress] = React.useState(null)
  const [barrio, setBarrio] = React.useState(null)
  const [name, setName] = React.useState(null)
  const [phone, setPhone] = React.useState(null)
  const [email, setEmail] = React.useState("")
  const [instructions, setInstructions] = React.useState(null)
  const [barrios, setBarrios] = React.useState([]);

  const { tr   } = useTranslations();

  const [nickname, setNickname] = React.useState(tr('Home'))

  React.useEffect(() => {
    //console.log("useEffect", props.city, props.province)
    setCity(props.city)
    setProvince(props.province)

    const input = document.querySelector("#add-address-phone");
    // window.intlTelInput(input, {
    //   //loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.1/build/js/utils.js"),
    // });

  }, [props.city, props.province, props.country]);

  const doSubmit = () => {
    if (name === null || name.length < 3) {
      alert(tr("Please enter a contact name"))
      return
    }

    if (city === null || city.length < 3) {
      alert(tr("Please enter a valid city"))
      return
    }

    if (address === null || address.length < 5) {
      alert(tr("Please enter a valid address"))
      return
    }
    if (phone === null || phone.length < 12) {
      alert(tr("Please enter a valid phone number"))
      return
    }

    let addressObj = {
      name: name,
      city: city,
      province: province,
      address: address,
      barrio: barrio,
      phone: `+${phone}`,
      email: email.trim(),
      title: nickname,
      instructions: instructions
    }

    //console.log("doSubmit", addressObj)

    props.onSubmit(addressObj)
  }

  return (
   <dialog id="add-address-form-dialog">
     <div className="modal-dialog modal-dialog-centered"
      centered="true"
    >
      <div className="modal-header"  >
        <h5 id="add-address">{tr("Add Delivery Address")}</h5>
        <button type="button" className="close"
          onClick={() => {
            props.onHide()
          }}
        ><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
      </div>

      <div className="modal-body">
        <form>
          <div className="form-row">

            <div className="form-group col-md-12">
              <label>{tr("Name")}</label>
              <input className="form-control" type="text" placeholder={tr("Contact name")}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setName(event.target.value)
                }} />
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Address")}</label>
              <input className="form-control" type="text" placeholder={tr("Complete Address e.g. house number, street name, landmark")}
                onChange={(event) => {
                  // console.log("address", event.target.value)
                  setAddress(event.target.value)
                }}
              />
            </div>

            {props.barrios && props.barrios.length > 0 && props.location && props.location.flags && props.location.flags.includes("barrioPricing") &&

              <div className="form-group col-md-12">
                <label>{tr("Barrio")}</label>
                <select
                  className="form-control"
                  onChange={(e) => {
                    setBarrio(e.target.value)
                  }}
                >
                  <option value="">Eligir Barrio</option>
                  {barrios.map((barrio) => {
                    return <option key={barrio} value={capitalize(barrio)}>
                      {capitalize(barrio)}</option>
                  })}
                </select>

              </div>
            }


            <div className="form-group col-md-12">
              <label>{tr("City")}</label>
              <div className="input-group" >
                <input className="form-control" type="text" placeholder={tr("City")}
                  defaultValue={city}
                  onChange={(event) => {
                    // console.log("city", event.target.value)
                    setCity(event.target.value)
                  }}
                />

              </div>
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Province")}</label>
              <div className="input-group" >
                <input className="form-control" type="text" placeholder={tr("Province")}
                  defaultValue={province}
                  onChange={(event) => {
                    // console.log("province", event.target.value)
                    setProvince(event.target.value)
                  }}
                />

              </div >
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Phone")} {tr("including country code")}</label>
              <input id="add-address-phone" type="tel"
                onChange={(event) => {
                  console.log("phone", event)
                  setPhone(event)
                }}
                style={{ width: "100%" }}
              />

            </div>

            <div className="form-group col-md-12">
              <label>{tr("Email")}</label>
              <input className="form-control" type="text" placeholder={tr("Email for confirmation and receipt")}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setEmail(event.target.value)
                }} />
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Delivery Instructions")}</label>
              <input className="form-control" type="text" placeholder={tr("Delivery Instructions e.g. Ring top bell")}
                onChange={(event) => {
                  // console.log("instructions", event.target.value)
                  setInstructions(event.target.value)
                }}
              />
            </div>

            <div className="form-group mb-0 col-md-12">
              <label>{tr("Nickname")}</label>
              <div role="toolbar" className="btn-toolbar">
                <div role="group" className="d-flex w-100 btn-group btn-group-toggle"
                  onChange={(val) => {
                    console.log("nickname", val)
                    switch (val) {
                      case 1:
                        setNickname(tr("Home"))
                        break;

                      case 2:
                        setNickname(tr("Work"))
                        break;

                      case 3:
                        setNickname(tr("Other"))
                        break;
                      default:
                        setNickname(tr("Unknown"))
                    }
                  }}
                >
                  <label className="btn active btn-info">
                    <input name="options" type="radio" autoComplete="off" value="1"  />{tr("Home")}
                  </label>
                  <label className="btn btn-info">
                    <input name="options" type="radio" autoComplete="off" value="2" />{tr("Work")}
                  </label>
                  <label className="btn btn-info">
                    <input name="options" type="radio" autoComplete="off" value="3" />{tr("Other")}
                  </label>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="modal-footer">
        <button type='button' onClick={props.onHide} className="btn btn-outline-primary d-flex w-50 text-center justify-content-center">{tr("CANCEL")}</button>
        <button type='button' className='btn btn-primary d-flex w-50 text-center justify-content-center'
          onClick={doSubmit}
        >{tr("SUBMIT")}</button>
      </div>
    </div>
   </dialog>
  );
}
export default AddAddressFormModal;
*/